        document.addEventListener('DOMContentLoaded', function() {
            const popup = document.getElementById('coffee-popup');
            const trigger = document.getElementById('coffee-popup-trigger');
            const closeBtn = document.getElementById('popup-close');

            if (trigger) {
                trigger.addEventListener('click', function(e) {
                    e.preventDefault();
                    if (popup) {
                        popup.style.display = 'flex';
                    }
                });
            }

            if (closeBtn) {
                 closeBtn.addEventListener('click', function() {
                    if (popup) {
                        popup.style.display = 'none';
                    }
                });
            }
            
            if (popup) {
                 popup.addEventListener('click', function(e) {
                    // Close popup if the overlay (background) is clicked, but not the content inside
                    if (e.target === popup) {
                        popup.style.display = 'none';
                    }
                });
            }
        });